import styled from "styled-components";

export const Button = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  box-sizing: border-box;
  color: inherit;
  display: inline-flex;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  justify-content: center;
  margin: 0;
  outline: 0;
  padding: 0;
  user-select: none;
  vertical-align: top;
  &:hover:not(:disabled) {
    cursor: pointer;
  }
  &::-moz-focus-inner {
    border: 0;
  }
`;
